import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "main",
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: "/home",
    name: "home",
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: "/training",
    name: "training",
    component: () => import('@/pages/TrainingPage.vue'),
  },
  {
    path: "/bikefitting",
    name: "bikefitting",
    component: () => import('@/pages/BikeFittingPage.vue'),
  },
  {
    path: "/hartcoherentie",
    name: "hartcoherentie",
    component: () => import('@/pages/HartCoherentiePage.vue'),
  },
  {
    path: "/kinesitherapie",
    name: "kinesitherapie",
    component: () => import('@/pages/KinePage.vue'),
  },
  {
    path: "/team/:id",
    name: "team",
    component: () => import('@/pages/TeamDetailPage.vue'),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import('@/pages/ContactPage.vue'),
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/NotFound.vue'),
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      /*return {
        el: to.hash,
        behavior: 'smooth',
      };*/
      // Adjust the offset here
      const element = document.querySelector(to.hash);
      if (element) {
        // Calculate the position with offset for the navbar
        const offset = 90; // Adjust the offset value according to your navbar height
        const top = element.getBoundingClientRect().top + window.scrollY - offset;
        
        return { top, behavior: 'smooth' };
      }
    } else {
      return { top: 0 };
    }
  },
});

export default router;